import { __assign } from "tslib";
import React from 'react';
import { CnBadge as PCCnBadge } from '@cainiaofe/cn-ui';
var CnBadge = function (props) {
    var shape = props.shape;
    var dot = shape === 'dot';
    return React.createElement(PCCnBadge, __assign({}, props, { dot: dot }));
};
export { CnBadge };
export var Badge = CnBadge;
